import { render, staticRenderFns } from "./TalkAskExperience.vue?vue&type=template&id=bff50c9e&scoped=true&"
import script from "./TalkAskExperience.vue?vue&type=script&lang=ts&"
export * from "./TalkAskExperience.vue?vue&type=script&lang=ts&"
import style0 from "./TalkAskExperience.vue?vue&type=style&index=0&id=bff50c9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff50c9e",
  null
  
)

export default component.exports